import { TRDX_CHAIN_ID, TRDX_TOKEN_ADDRESS } from "./trdxContractConfig";

export const TRDX_TOKEN_SYMBOL = "TRDX";
export const TRDX_TOKEN_DECIMALS = 18;
export const TRDX_TOKEN_LOGO_PATH = "/assets/tokens/trdx-token.png";

/** Absolute HTTPS URL for MetaMask token list logo (required by wallet_watchAsset). */
export function getTrdxTokenLogoUrl() {
  const publicBase = String(process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const path = `${publicBase}${TRDX_TOKEN_LOGO_PATH}`;
  if (typeof window !== "undefined" && window.location?.origin) {
    return new URL(path, window.location.origin).href;
  }
  return `https://treydora.com${TRDX_TOKEN_LOGO_PATH}`;
}

export function getTrdxMetaMaskManualImportHint() {
  return {
    network: "Ethereum Mainnet",
    contract: TRDX_TOKEN_ADDRESS,
    symbol: TRDX_TOKEN_SYMBOL,
    decimals: TRDX_TOKEN_DECIMALS,
  };
}

function normalizeChainIdHex(chainId) {
  const raw = String(chainId || "").trim().toLowerCase();
  if (!raw) return "";
  if (raw.startsWith("0x")) return raw;
  const n = parseInt(raw, 10);
  return Number.isFinite(n) ? `0x${n.toString(16)}` : raw;
}

async function ensureTrdxChain(ethereum) {
  const targetHex = `0x${Number(TRDX_CHAIN_ID).toString(16)}`;
  const current = normalizeChainIdHex(await ethereum.request({ method: "eth_chainId" }));
  if (current === targetHex) return;

  try {
    await ethereum.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: targetHex }],
    });
  } catch (err) {
    if (err?.code === 4001) {
      const rejected = new Error("Network switch was rejected in MetaMask.");
      rejected.code = "USER_REJECTED";
      throw rejected;
    }
    throw err;
  }
}

/**
 * Prompt MetaMask (or compatible wallet) to display TRDX via wallet_watchAsset.
 * Does not transfer, mint, or purchase tokens.
 */
export async function addTrdxToMetaMask() {
  const ethereum = typeof window !== "undefined" ? window.ethereum : null;
  if (!ethereum?.request) {
    const err = new Error(
      `MetaMask was not detected. You can manually import TRDX using contract ${TRDX_TOKEN_ADDRESS}.`
    );
    err.code = "NO_METAMASK";
    throw err;
  }

  await ensureTrdxChain(ethereum);

  try {
    const added = await ethereum.request({
      method: "wallet_watchAsset",
      params: {
        type: "ERC20",
        options: {
          address: TRDX_TOKEN_ADDRESS,
          symbol: TRDX_TOKEN_SYMBOL,
          decimals: TRDX_TOKEN_DECIMALS,
          image: getTrdxTokenLogoUrl(),
        },
      },
    });

    if (added === false) {
      const err = new Error("MetaMask did not add TRDX to your token list.");
      err.code = "WATCH_ASSET_DECLINED";
      throw err;
    }

    return { ok: true };
  } catch (err) {
    if (err?.code === 4001 || /user rejected|user denied/i.test(String(err?.message || ""))) {
      const rejected = new Error("TRDX import was cancelled in MetaMask.");
      rejected.code = "USER_REJECTED";
      throw rejected;
    }
    throw err;
  }
}
